import { useLocalization } from "@fluent/react";
import { Button, Row } from "@narmi/design_system";
import { API_VERSION } from "byzantine/src/ApiHttp";
import { useNotificationContext } from "cerulean";

import { useUserFeatures } from "../../../../../components/contexts/UserFeaturesContext";

interface LedgerPanelFooterProps {
  transaction: API.Transaction;
  onReportIssue: (transaction: API.Transaction) => void;
}

const LedgerPanelFooter = ({
  transaction,
  onReportIssue,
}: LedgerPanelFooterProps) => {
  const { l10n } = useLocalization();
  const { sendNotification } = useNotificationContext();
  const userFeatures = useUserFeatures();

  return (
    <Row alignItems="center" justifyContent="end" gapSize="s">
      {userFeatures.show_transaction_contact_support && (
        <Row.Item shrink>
          <Button
            kind="plain"
            label={l10n.getString("button-report-issue")}
            onClick={() => onReportIssue(transaction)}
            testId="ledger-panel-report-issue"
          />
        </Row.Item>
      )}
      <Row.Item shrink>
        <Button
          as="a"
          kind="primary"
          label={l10n.getString("button-download")}
          href={`${API_VERSION}transactions/${transaction.id}?file_format=pdf`}
          onClick={() => {
            sendNotification({
              type: "success",
              text: l10n.getString("transaction-download-started"),
            });
          }}
          testId="ledger-panel-download"
        />
      </Row.Item>
    </Row>
  );
};

export default LedgerPanelFooter;
